import { API_endpoints } from "../config";

export const getBlockData = async (block_id:number): Promise<any> => {
    try {

        const response = await fetch(API_endpoints.getBlockData, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ block_id }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von block Daten.");
        }

        return await response.json();
    } catch (error) {
        console.error("Fehler beim Laden block von Daten:", error);
    }
};